import { createSelector } from '@reduxjs/toolkit';

import { type CoeVendor, type CoeProgram } from 'schemas';
import { type ReduxSelector } from '../../store.types';
import {
  type CoeVendorMap,
  type CoeProgramMap,
  type CoeVendorWithPrograms,
  type CoeProgramWithVendor,
} from './coe.types';
import { COE_SLICE_NAME } from '../slicesNames';

export const vendorMap: ReduxSelector<CoeVendorMap> = (state) => state[COE_SLICE_NAME].vendors;
export const programMap: ReduxSelector<CoeProgramMap> = (state) => state[COE_SLICE_NAME].programs;

export const vendorList: ReduxSelector<CoeVendorWithPrograms[]> = createSelector(
  [vendorMap],
  (vendorMapState) => Object.values(vendorMapState)
);

export const programList: ReduxSelector<CoeProgramWithVendor[]> = createSelector(
  [programMap],
  (programMapState) => Object.values(programMapState)
);

export const vendorById = (id: CoeVendor['id']): ReduxSelector<CoeVendorWithPrograms | undefined> =>
  createSelector([vendorMap], (vendorMapState) => vendorMapState[id]);

export const programById = (
  id: CoeProgram['id']
): ReduxSelector<CoeProgramWithVendor | undefined> =>
  createSelector([programMap], (programMapState) => programMapState[id]);
